export default __webpack_public_path__ + "static/bailleur@2x-792adbd0e706044ee80d49093554817f.png";